import { render, staticRenderFns } from "./InternationalRevocationDialog.vue?vue&type=template&id=5fc4a0aa&scoped=true"
import script from "./InternationalRevocationDialog.vue?vue&type=script&lang=js"
export * from "./InternationalRevocationDialog.vue?vue&type=script&lang=js"
import style0 from "./InternationalRevocationDialog.vue?vue&type=style&index=0&id=5fc4a0aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc4a0aa",
  null
  
)

export default component.exports